import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PwInputComponent } from './pw-input.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';



@NgModule({
  declarations: [
    PwInputComponent
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule
  ],
  exports: [
    PwInputComponent
  ]
})
export class PwInputModule { }
